import './App.css';
import {
	BrowserRouter,
	Navigate,
	Outlet,
	Route,
	Routes,
	useLocation,
} from 'react-router-dom';
import Home from './pages/Home/Home';
import AddResident from './pages/AddResident';
import CreateCareNote from './pages/CreateCareNote';
import CreateCarePlan from './pages/CarePlan/CreateCarePlan';
import { ToastAlert } from './components/ToastAlert';
import AddPlanConfiguration from './pages/AddPlanConfiguration';
import UsersDashboard from './pages/SuperAdmin/UsersDashboard';
import Login from './pages/Login';
import { getAccessToken, getUserRole } from './Utils/AuthUtil';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import MedicalAssistant from './pages/MedicalAssistant';
import DeleteAccountPage from './pages/DeleteAccountInstructions';
import CreateAccount from './pages/CreateAccount';
import InitialCarePlanMain from './pages/InitialCarePlan/InitialCarePlanMain';
import FeedbackDashboard from './pages/SuperAdmin/FeedbackDashboard';
import DetailSummarizer from './pages/DetailSummarizer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import SessionGuard from './components/SessionGuard';
import APIIntegration from './pages/APIIntegration';
import { USER_ROLES } from './Utils/Enums';
import AdminDashboard from './pages/AdminDashboard';
import NotificationSending from './pages/NotificationSending';

function App() {
	return (
		<>
			<BrowserRouter>
				<SessionGuard />
				<Routes>
					<Route element={<AuthenticationRoutes />}>
						<Route path="/" element={<Login />} />
						<Route
							path="/reset/role/:roleId/key/:keyId/id/:userId"
							element={<ResetPassword />}
						/>
						<Route path="/reset" element={<ForgotPassword />} />
						<Route
							path="/deleteAccount"
							element={<DeleteAccountPage />}
						/>
						<Route
							path="/createAccount"
							element={<CreateAccount />}
						/>
						<Route
							path="/privacy-policy"
							element={<PrivacyPolicy />}
						/>
						<Route path="/terms-of-use" element={<TermsOfUse />} />
					</Route>
					<Route element={<SuperAdminRoutes />}>
						<Route path="/admin" element={<UsersDashboard />} />
						<Route
							path="/feedback"
							element={<FeedbackDashboard />}
						/>
					</Route>
					<Route element={<PrivateRoutes />}>
						<Route path="/home" element={<Home />} />
						<Route path="/addResident" element={<AddResident />} />
						<Route path="/careNote" element={<CreateCareNote />} />
						<Route path="/carePlan" element={<CreateCarePlan />} />
						<Route
							path="/configuration"
							element={<AddPlanConfiguration />}
						/>
						<Route
							path="/assistant"
							element={<MedicalAssistant />}
						/>
						<Route
							path="/initialCarePlan"
							element={<InitialCarePlanMain />}
						/>
						<Route
							path="/summarizer"
							element={<DetailSummarizer />}
						/>
						<Route
							path="/integration"
							element={<APIIntegration />}
						/>
						<Route path="/users" element={<AdminDashboard />} />
						<Route
							path="/notifications"
							element={<NotificationSending />}
						/>
					</Route>
				</Routes>
			</BrowserRouter>
			<ToastAlert />
		</>
	);
}

function PrivateRoutes() {
	return getAccessToken() &&
		(parseInt(getUserRole()) === USER_ROLES.admin ||
			parseInt(getUserRole()) === USER_ROLES.staff) ? (
		<Outlet />
	) : (
		<Navigate to="/" />
	);
}

function SuperAdminRoutes() {
	return getAccessToken() &&
		parseInt(getUserRole()) === USER_ROLES.superAdmin ? (
		<Outlet />
	) : (
		<Navigate to="/" />
	);
}

function AuthenticationRoutes() {
	const location = useLocation();
	const path = location.pathname;
	const userRole = parseInt(getUserRole());

	if (getAccessToken()) {
		if (checkIsAllowedWhileLoggedIn(path)) {
			return <Outlet />;
		}

		if (userRole === USER_ROLES.admin || userRole === USER_ROLES.staff) {
			return <Navigate to="/home" />;
		}

		if (userRole === USER_ROLES.superAdmin) {
			return <Navigate to="/admin" />;
		}
	}

	return <Outlet />;
}

function checkIsAllowedWhileLoggedIn(path) {
	const routePaths = [
		'/reset/role/',
		'/privacy-policy',
		'/terms-of-use',
		'/deleteAccount',
	];

	for (let i = 0; i < routePaths.length; i++) {
		if (path.startsWith(routePaths[i])) {
			return true;
		}
	}
	return false;
}

export default App;
